import es from './es';
import en from './en';

const translations = {
  es,
  en,
};

export default translations;
